import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, from } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import * as actions from './stack-location-get.actions';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';

import { ApiOrdMethod } from 'src/app/api/api-methods.ord';
import { StackLocationGetI } from 'src/app/api/stack-location-get/stack-location-get.result.int';
import { spxToasterActions } from '@softpak/components/spx-toaster';

@Injectable()
export class StackLocationGetEffects {
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericSerivce = inject(SharedGenericService);

    load$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(action => from(this.sharedGenericSerivce.invoke(ApiOrdMethod.getStackLocation, action.query))
            .pipe(
                map((result: StackLocationGetI) => actions.received({
                    result
                })),
                catchError((error) => {
                    console.error(error);
                    return [
                        actions.error({
                            messageText: error,
                        }),
                        spxToasterActions.createError({
                            autoClose: error.autoclose ? 5000 : undefined,
                            messageText: `${error?.title ? `${error?.title}: ` : ``} ${error.message}`,
                        }),
                    ];
                })
            )))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => [
            // spf.spinner.SHOW({
            // }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => [
            // spf.spinner.HIDE({
            // }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        mergeMap(() => [
            // spf.spinner.HIDE({
            // }),
        ]))
    );
}
